import { AppPageHead } from "./app.page.head";
import { AppPageTemplate } from "./app.page.template";


/**
 * 页面数据列表对象
 */
export class AppPageConfig {
    Data: Data;
    Key: string;
}
export class Data {
    /**
     * 页面名称
     */
    name: string;
    /**
     * 版本号
     */
    version: string;
    /**
     * 头部配置节点
     */
    head: AppPageHead ;
    /**
     * 页面主体模块
     */
    template: Array<AppPageTemplate> = new Array<AppPageTemplate>();
}